'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Token = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var genCookieKeyForEnv = function genCookieKeyForEnv(env, key) {
  return env + '-' + key;
};

var Token = function () {
  function Token() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$cookieEnvKey = _ref.cookieEnvKey,
        cookieEnvKey = _ref$cookieEnvKey === undefined ? 'qcde' : _ref$cookieEnvKey,
        _ref$cookieAppKey = _ref.cookieAppKey,
        cookieAppKey = _ref$cookieAppKey === undefined ? 'qid' : _ref$cookieAppKey;

    _classCallCheck(this, Token);

    this.cookieEnvKey = cookieEnvKey;
    this.cookieAppKey = cookieAppKey;
  }

  _createClass(Token, [{
    key: 'getCookieKey',
    value: function getCookieKey() {
      var env = _jsCookie2.default.get(this.cookieEnvKey);

      return genCookieKeyForEnv(env, this.cookieAppKey);
    }
  }, {
    key: 'getTokenFromCookie',
    value: function getTokenFromCookie() {
      return _jsCookie2.default.get(this.getCookieKey());
    }
  }, {
    key: 'isTokenValid',
    value: function isTokenValid() {
      var token = this.getTokenFromCookie();

      if (token && token.length) {
        return true;
      }

      this.deleteToken();
      return false;
    } //Make sure you use this function correctly.
    //When domain is specified for a cookie you need to pass it here as well.
    //More information: https://github.com/js-cookie/js-cookie

  }, {
    key: 'deleteToken',
    value: function deleteToken(domain) {
      _jsCookie2.default.remove(this.getCookieKey(), domain);
    }
  }, {
    key: 'getBearerToken',
    value: function getBearerToken() {
      var cookie = this.getTokenFromCookie() || '';
      var decodedCookie = new Buffer(cookie, 'base64').toString();

      if (decodedCookie) {
        return 'Bearer ' + JSON.parse(decodedCookie).auth;
      }
    }
  }, {
    key: 'getAuthHeader',
    value: function getAuthHeader() {
      var token = this.getBearerToken();
      if (token) return {
        Authorization: token
      };
    }
  }]);

  return Token;
}();

exports.Token = Token;